import React from "react";
import { ReactComponent as ComboChartIcon } from "assets/icons/combo_chart.svg";
import { ReactComponent as MultiportalPresenceIcon } from "assets/icons/multiportal_presence.svg";
import { ReactComponent as LocationIntelligence } from "assets/icons/location_intelligence.svg";
import analysisDashboardPage from "assets/images/5th.webp";
import RevealAnimationSection from "components/Animation/RevealAnimationSection";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";
const AnalysisDashboardSection = () => {
  const { openSignupDialog } = useDialog();
  const { user } = useAuth();

  return (
    <div className="lg:pt-[55px] lg:pb-[71px] py-10 px-5 bg-[#f5f5f5] overflow-hidden">
      <RevealAnimationSection direction="right">
        {/* mobile heading  */}
        <h1 className="leading-normal lg:hidden mb-[25px] text-center font-bold text-[30px] ">
          La <span className="text-primary">Dashboard</span> per l’analisi
        </h1>
        <div className="flex items-center justify-center flex-col-reverse lg:flex-row space-y-5 lg:space-y-0">
          <div className="lg:w-[50%] w-full">
            <div className="lg:max-w-[87%] flex items-center lg:items-start flex-col">
              {/* dasktop heading  */}
              <h1 className="leading-[48.41px] hidden lg:block font-bold text-[40px] ">
                La <span className="text-primary">Dashboard</span> per l’analisi
              </h1>
              <p className="text-[14px] lg:text-start text-center font-normal leading-[24px] lg:leading-[28px] mt-[25px] lg:mt-[18px]">
                E’ lo strumento che ti darà accesso a strumenti avanzati per
                monitorare il mercato immobiliare, scoprire le migliori
                opportunità di investimento e massimizzare i tuoi profitti
              </p>
              <div className="mt-[20px] hidden lg:block">
                <div className="flex items-start space-x-[7px]">
                  <ComboChartIcon />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Aggiornamenti sui Prezzi delle Proprietà Salvate{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Resta aggiornato sulle variazioni di prezzo delle
                      proprietà salvate, cogliendo le migliori opportunità del
                      mercato.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <MultiportalPresenceIcon className="mt-[6px] min-w-[20px]" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Le proprietà con il miglior rapporto prezzo/mq {" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Scopri le proprietà che offrono il miglior valore per
                      metro quadro, Housescan compara e analizza le quotazioni
                      per aiutarti a fare investimenti profittevoli.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <LocationIntelligence className="mt-1" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Zone con Alti Rendimenti Locativi{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Identifica le aree geografiche che offrono i migliori
                      rendimenti locativi e utilizza questi dati per orientare
                      le tue decisioni di investimento.
                    </p>
                  </div>
                </div>
              </div>
              {!user && (
                <button
                  onClick={openSignupDialog}
                  className="lg:mt-5 mt-[25px] shadow-sm w-[154px] lg:w-[247px] h-[47px] lg:h-[55px] flex items-center justify-center border-[1px] border-[#4AB4F5] hover:bg-transparent rounded-[4px] font-semibold hover:text-primary text-[14px] bg-[#1DA1F2] text-white transition-all duration-400 ease-linear"
                >
                  ISCRIVITI
                </button>
              )}
            </div>
          </div>

          <img
            className="h-full lg:w-[50%] w-full"
            src={analysisDashboardPage}
            alt="Dashboard Page"
          />
        </div>
      </RevealAnimationSection>
    </div>
  );
};

export default AnalysisDashboardSection;
